import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] pt-16 flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20flat%20lay%20of%20carefully%20curated%20fashion%20essentials%20including%20designer%20sneakers%20a%20folded%20cashmere%20sweater%20and%20a%20leather%20bag%20on%20a%20warm%20cream%20textured%20linen%20surface%2C%20soft%20natural%20window%20light%20creating%20delicate%20shadows%2C%20editorial%20catalog%20photography%20with%20warm%20neutral%20beige%20and%20sand%20tones%2C%20harmonious%20composition%20with%20thoughtful%20negative%20space&width=1800&height=1200&seq=hero-v2-brandnew&orientation=landscape"
        alt="CSSBuy Spreadsheet curated fashion collection"
        title="CSSBuy Spreadsheet - Curated Shopping Lists"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-4">
          Discover the Best<br />
          <span className="italic font-normal">CSSBuy Sheet</span> Collections
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Curated spreadsheets for every category &mdash; shoes, clothing, bags, and more.
          Find the best agent shopping lists, updated weekly for 2026.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center px-8 py-3.5 rounded-full bg-white/20 backdrop-blur-sm text-white font-medium text-base hover:bg-white/30 transition-all cursor-pointer border border-white/30 whitespace-nowrap"
        >
          Buy It Now
          <span className="w-4 h-4 flex items-center justify-center ml-2">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </a>
      </div>
    </section>
  );
}